module.exports = __webpack_public_path__ + "img/awards-and-ratings-card.83b3c362.png";